import { FormType } from '../../../form-types';
import { ZaludPinkEyeQuestionFieldAnswers } from './questions';

const pinkEye: FormType<ZaludPinkEyeQuestionFieldAnswers> = {
  name: 'Pink Eye Intake',
  questions: [
    'zalud_pinkEye_redFlagSymptoms',
    'zalud_pinkEye_symptomDuration',
    'zalud_pinkEye_eyesAffected',
    'zalud_pinkEye_symptoms',
    'zalud_pinkEye_visionChanges',
    'zalud_pinkEye_contactLensHistory',
    'zalud_pinkEye_closeContact',
    'zalud_pinkEye_seasonalAllergies',
    'zalud_pinkEye_additionalComments',
    {
      key: 'zalud_pinkEye_consent',
      next: {
        condition: { 'zalud_pinkEye_consent.proceed': true },
        key: 'zalud_pinkEye_complete',
        els: 'zalud_pinkEye_ineligible'
      }
    },
    'zalud_pinkEye_complete',
    'zalud_pinkEye_ineligible'
  ]
};

export default pinkEye;
